import HttpFactory from '~/repository/factory'
import type { GenerateFlpReturn } from '~/types/generate-flp-return'

class FlpModule extends HttpFactory {
    private RESOURCE = '/full-life-planning'

    async generateFlp(id: string): Promise<GenerateFlpReturn> {
        return await this.get(`${this.RESOURCE}/generate/${id}`)
    }
}

export default FlpModule